import { dictionariesApi, enumsApi, studyCalendarApi } from '@/api'
import { Models } from '@/constants/dictionary'
import _ from 'lodash'

const api = {
  auditoryNumber: 'getAuditoryNumber',
  dayName: 'getDayName',
  lectorName: 'getLectorName',
  lectorsForCurrentUser: 'getLectorsForCurrentUser',
  locationAddress: 'getLocationAddress',
  pairTime: 'getPairTime',
  studyGroup: 'getStudyGroup',
  subgroup: 'getSubgroup',
  subjectName: 'getSubjectName',
  weekNumber: 'getWeekNumber',
  lessonType: 'getLessonType',
  groupStream: 'getGroupStream',
  stream: 'getStream',
  speciality: 'getSpeciality',
  courseNumber: 'getCourseNumber',
  academicYear: 'getAcademicYear',
  semester: 'getSemester',
  pivotField: 'getPivotField',
  disciplineOriginal: 'getDisciplineOriginal',
  disciplineGenerated: 'getDisciplineGenerated',
  subgroupLiterra: 'getSubgroupLiterra',
  pivotFieldArrangement: 'getPivotFieldArrangement'
}

export default {
  namespaced: true,

  state: {
    auditoryNumber: [],
    dayName: [],
    lectorName: [],
    lectorsForCurrentUser: [],
    locationAddress: [],
    pairTime: [],
    groupStream: [],
    stream: [],
    studyGroup: [],
    subgroup: [],
    subjectName: [],
    weekNumber: [],
    lessonType: [],
    speciality: [],
    courseNumber: [],
    academicYear: [],
    semester: [],
    pivotField: [],
    disciplineOriginal: [],
    disciplineGenerated: [],
    boolean: [
      { id: 0, name: false },
      { id: 1, name: true }
    ],
    subgroupLiterra: [],
    studyCalendar: [],
    pivotFieldArrangemen: [],

    enums: {
      semester: []
    },

    allDictionaryLoading: false
  },

  getters: {
    courseNumber: state => state.courseNumber,
    stream: state => state.stream,
    speciality: state => state.speciality,
    semester: state => state.semester,
    lectorsForCurrentUser: state => state.lectorsForCurrentUser,
    boolean: state => state.boolean,
    subgroupLiterra: state => state.subgroupLiterra,
    academicYear: state => state.academicYear,
    studyCalendar: state => state.studyCalendar,
    pivotFieldArrangement: state => state.pivotFieldArrangement,
    disciplineOriginal: state => state.disciplineOriginal,
    disciplineGenerated: state => state.disciplineGenerated
  },

  mutations: {
    setDirectory(state, payload) {
      if (payload.model === Models.dayName) {
        const dayOrder = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс']
        payload.data.sort((a, b) => dayOrder.indexOf(a.name) - dayOrder.indexOf(b.name))
      }
      state[payload.model] = payload.data
    },

    setEnums(state, payload) {
      state.enums[payload.model] = payload.data
    },

    setLoading(state, payload) {
      state.allDictionaryLoading = payload
    },
    setStudyCalendar(state, payload) {
      state.studyCalendar = payload
    }
  },

  actions: {
    async getDirectory({ commit }, payload) {
      // if (_.isEmpty(state[payload]))
      commit('setDirectory', {
        model: payload,
        data: await dictionariesApi[api[payload]]()
      })
    },
    async getStudyCalendar({ commit }) {
      try {
        const data = await studyCalendarApi.findAll()

        const items = data
          .map(item => ({
            id: item.id,
            academicYear: item.academicYear,
            semesterName: item.semester?.name
          }))
          .sort((a, b) => Number(b.academicYear) - Number(a.academicYear))
          .map(item => ({
            id: item.id,
            name: `${item.academicYear}/${item.semesterName || '-'}`
          }))
        commit('setStudyCalendar', items)
      } catch (error) {
        console.error('Нет данных studyCalendar', error)
        commit('setStudyCalendar', [])
      }
    },

    async getAllDirectory({ dispatch, commit }) {
      commit('setLoading', true)
      const directory = [
        Models.auditoryNumber,
        Models.dayName,
        Models.lectorName,
        Models.lectorsForCurrentUser,
        Models.locationAddress,
        Models.pairTime,
        Models.studyGroup,
        Models.subgroup,
        Models.subjectName,
        Models.stream,
        Models.subgroupLiterra,
        Models.weekNumber,
        Models.lessonType,
        Models.academicYear,
        Models.courseNumber,
        Models.groupStream,
        Models.speciality,
        Models.semester,
        Models.disciplineOriginal,
        Models.disciplineGenerated,
        Models.pivotFieldArrangement
      ]

      for (let item of directory) {
        try {
          await dispatch('getDirectory', item)
        } catch (e) {
          console.error(e)
        }
      }
      await dispatch('getStudyCalendar')

      commit('setLoading', false)
    },

    async getEnum({ state, commit }, payload) {
      if (_.isEmpty(state.enums[payload])) {
        commit('setEnums', {
          model: payload,
          data: await enumsApi[api[payload]]()
        })
      }
    }
  }
}
